import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { UUID } from "angular2-uuid";
import { ChangeQItem } from "../../../core/services/sync-up/item";
import * as actions from "./membership.actions";

@Injectable()
export class MembershipSideEffects {

    @Effect({dispatch: false})
    $refresh = this.actions$
        .ofType(actions.REFRESH)
        .do((action: actions.RefreshAction) => {
            const membership = action.payload;
            const changeQItem = new ChangeQItem({
                id: membership.id,
                method: "REFRESH",
                entity: "membership",
                account: membership.account,
                key: UUID.UUID(),
                user: membership.user,
                data: membership
            });

            this.appFacade.objects.syncUpItem.store.createFromChangeQItem(changeQItem);
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.side-effects.ts